export default __webpack_public_path__ + "locales/sk/Webhooks.json?hash=2d032b11d6e337dfe6d4252597682015";